import { zodResolver } from '@hookform/resolvers/zod';
import {
  Button,
  DialogActions,
  DialogContent,
  Divider,
  Form,
  FormTextField,
} from '@shared/components';
import { FormProvider, useForm } from 'react-hook-form';
import { z } from 'zod';

export type DuplicateQBankStructureFormInput = z.infer<typeof DuplicateQBankStructureFormSchema>;

interface DuplicateQBankStructureFormProps {
  onClose: () => void;
  onSubmit: (formValues: DuplicateQBankStructureFormInput) => Promise<void>;
  loading?: boolean;
  defaultValues?: DuplicateQBankStructureFormInput;
}

const NAME_MAX_LENGTH = 1024;
const NAME_MIN_LENGTH = 1;

const DuplicateQBankStructureFormSchema = z.object({
  name: z
    .string()
    .trim()
    .min(NAME_MIN_LENGTH, {
      message: 'กรุณากรอกชื่อคลังข้อสอบ',
    })
    .max(NAME_MAX_LENGTH, {
      message: `ชื่อคลังข้อสอบต้องมีความยาวไม่เกิน ${NAME_MAX_LENGTH} ตัวอักษร`,
    }),
});

export default function DuplicateQBankStructureForm(
  props: Readonly<DuplicateQBankStructureFormProps>,
) {
  const { defaultValues, loading: isLoading = false, onClose, onSubmit } = props;

  const formContext = useForm<DuplicateQBankStructureFormInput>({
    defaultValues,
    resolver: zodResolver(DuplicateQBankStructureFormSchema),
  });

  const handleSubmit = async (data: DuplicateQBankStructureFormInput) => {
    onSubmit(data);
  };

  return (
    <FormProvider {...formContext}>
      <Form onSubmit={formContext.handleSubmit(handleSubmit)}>
        <DialogContent>
          <FormTextField
            label='ชื่อคลังข้อสอบ'
            name='name'
            placeholder='Placeholder'
            fullWidth
            required
          />
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            variant='outlined'
            color='secondary'
            onClick={onClose}
            disabled={isLoading}
            size='large'
          >
            Cancel
          </Button>
          <Button type='submit' loading={isLoading} size='large'>
            Duplicate
          </Button>
        </DialogActions>
      </Form>
    </FormProvider>
  );
}
